<template>
    <div>
        <div class="action-header">
            <div class="search-container">
                <div class="search-input mb-3">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.holiday.searchText')"
                        solo dense hide-details
                        height="40px"
                        @keyup.enter="searchHoliday()">
                    </v-text-field>
                    <v-btn
                        class="ml-3"
                        height="40px"
                        color="primary"
                        outlined
                        @click="searchHoliday()">
                        {{ $vuetify.lang.t('$vuetify.holiday.search') }}
                    </v-btn>
                </div>

                <div class=" filter-input year-input">
                    <v-menu
                        ref="menu"
                        :close-on-content-click="false"
                        v-model="menu"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="100px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                slot="activator"
                                v-model="displayYear"
                                prepend-inner-icon="event"
                                solo
                                @click:prepend-inner="menu = true"
                                v-on="on"
                                height="40"
                                background-color="#ffffff"
                                readonly>
                            </v-text-field>
                        </template>
                        <v-date-picker
                            class="mb-2"
                            ref="picker"
                            locale="th-TH"
                            v-model="year"
                            :max="maxDate"
                            @input="save"
                            reactive
                            no-title>
                        </v-date-picker>
                    </v-menu>
                </div>

            </div>
            <div>
                <v-btn
                    v-if="canUpdate"
                    height="40px"
                    @click="addHoliday()"
                    color="primary">
                    + {{ $vuetify.lang.t('$vuetify.holiday.addHoliday') }}
                </v-btn>
            </div>
        </div>
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalHoliday"
                :items="holidayList"
                :loading="loading">
                <template v-slot:[`item.action`]="{ item }">
                    <div class="action" v-if="canUpdate">
                        <div :class="actionStyle(item)">
                            <i class="mr-4 far fa-edit" @click="editHoliday(item)"></i>
                            <i class="mr-3 far fa-trash-alt" @click="deleteHoliday(item)"></i>
                        </div>
                    </div>
                </template>
            </v-data-table>
        </v-card>
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>

        <holiday-form-modal
            v-if="holidayFormModalShow"
            ref="holidayFormModal"
            @close="holidayFormModalShow = false"
            @success="searchHoliday()"
            :mode="mode"
            :holidayId="holidayId"/>

        <delete-modal
            ref="modalDelete"
            @success-deleted="deletedSuccess()"
            :deleteForm="deleteForm"/>
    </div>
</template>

<script>
import DeleteModal from '@/components/modal/DeleteModal.vue'
import HolidayFormModal from '@/components/TimeTableSetting/HolidayFormModal'

export default {
    name: 'Holiday',

    components: {
        HolidayFormModal,
        DeleteModal
    },

    data () {
        return {
            search: '',
            pageCount: 1,
            page: 1,
            options: {},
            loading: false,
            totalHoliday: 0,
            holidayList: [],
            mode: '',
            holidayFormModalShow: false,
            holidayId: null,
            menu: false,
            year: new Date().toISOString().substr(0, 10),
            maxDate: new Date().toISOString().substr(0, 10),
            displayYear: this.yearFormat(new Date().toISOString().substr(0, 10)),
            deleteForm: {
                header: '',
                content: '',
                path: ''
            },
            canUpdate: false
        }
    },

    computed: {
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.holiday.holidayName'), value: 'name', width: '50%' },
                { text: this.$vuetify.lang.t('$vuetify.holiday.createdDate'), value: 'created_at', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.holiday.holidayDate'), value: 'date', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.holiday.action'), value: 'action', width: '8%', align: 'center', sortable: false }
            ]
        }
    },

    methods: {
        async save (date) {
            this.$refs.menu.save(date)
            this.$refs.picker.activePicker = 'YEAR'
            this.menu = false
            await this.getHoliday()
        },

        getYear () {
            const [year] = this.year.split('-')
            return parseInt(year)
        },

        yearFormat (yearPick) {
            const [year] = yearPick.split('-')
            const BEYear = parseInt(year) + 543
            return `${BEYear}`
        },

        async searchHoliday () {
            this.options.page = 1
            await this.getHoliday()
        },

        async getHoliday () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options
            const year = this.getYear()

            let url = `holidays?page=${page}&itemsPerPage=${itemsPerPage}&year=${year}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.holidayList = res.data.data
                this.totalHoliday = res.data.total
                this.loading = false
            }
        },

        addHoliday () {
            this.mode = 'create'
            this.holidayFormModalShow = true
        },

        editHoliday (item) {
            this.holidayId = item.id
            this.mode = 'update'
            this.holidayFormModalShow = true
        },

        deleteHoliday (item) {
            this.deleteForm.header = this.$vuetify.lang.t('$vuetify.holiday.deleteHeader')
            this.deleteForm.content = `${this.$vuetify.lang.t('$vuetify.holiday.wantToDelete')} "${item.name}"? `
            this.deleteForm.path = `holiday/delete/${item.id}`
            this.$refs.modalDelete.dialog = true
        },

        async deletedSuccess () {
            this.$notify({
                title: this.$vuetify.lang.t('$vuetify.holiday.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.holiday.deletedHoliday'),
                type: 'success'
            })
            await this.searchHoliday()
        },

        actionStyle (item) {
            const holiday = this.$dateUtil.dateBEStringToDateObj(item.date)
            return new Date() > holiday ? 'action-disable' : 'action-enable'
        }
    },

    async mounted () {
        this.canUpdate = await this.hasPermission(this.$constant.permission.TIMETABLE_SETTING.UPDATE)
    },

    watch: {
        options: {
            async handler () {
                await this.getHoliday()
            },
            deep: true
        },
        menu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
        },
        year () {
            this.displayYear = this.yearFormat(this.year)
        },
        '$vuetify.lang.current': {
            handler: async function () {
                await this.getHoliday()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.search-container {
    ::v-deep .v-input__control > .v-input__slot {
        width: 340px;
        min-height: auto !important;
        display: flex !important;
        align-items: center !important;
        box-shadow: none !important;
        border: 1px solid #a8a8a8 !important;

        ::v-deep .search-input {
            align-items: center;
            .v-input__control > .v-input__slot {
                width: 340px;
            }
        }
    }

    ::v-deep .year-input .v-input__control > .v-input__slot {
        width: 200px;
    }

    ::v-deep .v-input__prepend-inner {
        margin: auto !important;
    }
}

.action {
    display: flex;
    align-items: center;

    .action-enable i {
        cursor: pointer;
    }

    .action-disable i {
        pointer-events: none;
        cursor: not-allowed !important;
        color: #a8a8a8 !important;
    }

    i {
        color: #6c6c6c;
    }
}
</style>
